import React from 'react';
import { AiOutlineMobile } from 'react-icons/ai';
import { BsTerminal } from 'react-icons/bs';
import { GoBrowser } from 'react-icons/go';

const careerInfo = [
  {
    id: 1,
    icon: <AiOutlineMobile />,
    title: 'Mobile Development',
    description: `Back end is not enough to consider myself as a full-stack developer, so, I've got solid knowledges in mobile technologies to complete my stack.`,
    knowledgeList: 'Kotlin, React Native, Expo',
  },
  {
    id: 2,
    icon: <GoBrowser />,
    title: 'Frontend Development',
    description: `I really ❤ Javascript, I started developing with native javascript and since there I've not stopped.`,
    knowledgeList:
      'HTML5, CSS3, Sass, JavaScript, Typescript, ES5, ES6, Webpack, JQuery, ReactJs, Socket.IO, Vue.js, Redux, Context , NextJs, Jest',
  },
  {
    id: 3,
    icon: <BsTerminal />,
    title: 'Backend Develoment & Others',
    description: `I've always worked as full-stack developer, and since the last 4 years I have focused with AWS ❤.`,
    knowledgeList:
      'Serverless, Jenkins, Bash, Git, Github, JavaScript, NodeJs, Express.js, Python, Laravel, Lumen, NestJS, MongoDB, PostgreSQL, MySQL, SQLite, Redis, Jest, Ava, Mocha, AWS, Docker, SCRUM.',
  },
];

export default careerInfo;
